import React from 'react';

import './EditPanelTripleButtonGroup.css';

const EditPanelTripleButtonGroup = ({ children }: { children: React.ReactNode }) => (
  <span className="EditPanelTripleButtonGroup">{children}</span>
);

export default EditPanelTripleButtonGroup;
